// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"abf62434","160":"96b7eb71","208":"d820aca3","293":"572ba72e","493":"c0efdc37","516":"6f9e3d7d","519":"0d0154e4","917":"0e688c71","946":"18416b1b"}[chunkId] + ".chunk.js";
};